/*
  PlayCircle.jsx
*/

import React from 'react';
import SvgIcon from '../components/SvgIcon';

export default function PlayCircle(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.5 16.5v-9l7 4.5-7 4.5z"></path>
    </SvgIcon>
  );
}
